/* eslint-disable array-callback-return */
import {
  Alert,
  Button,
  Card,
  CardContent,
  FormControl,
  FormHelperText,
  Grid,
  MenuItem,
  Paper,
  Select,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import axios from "../../CustomAxios";
import React, { useEffect, useRef, useState } from "react";
import Loading from "../components/Loading";
import { Add as AddIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";

export default function UpdatePlateDetails({ company }) {
  const navigate = useNavigate();
  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState("");
  const [loader, setLoader] = useState(true);
  const [plates, setPlates] = useState([]);
  const [prices, setPrices] = useState([]);
  const snackRef = useRef(null);
  const [selectedPlates, setSelectedPlates] = useState([]);
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const removePlate = (i, id) => {
    if (id) {
      setSelectedPlates((prev) => [...prev.filter((x) => x !== id)]);
    }
    setPrices((prev) => [...prev.slice(0, i), ...prev.slice(i + 1)]);
  };

  const priceHandle = (i, obj) => (e) => {
    let price = [...prices];
    if (obj === "plate_id") {
      price[i][obj] = e.target.value;
    } else {
      if (obj === "gripper") {
        if (e.target.value <= 99.99 && e.target.value >= 0.0) {
          price[i][obj] = parseFloat(e.target.value);
        }
      } else {
        price[i][obj] = parseInt(e.target.value);
      }
    }
    setPrices(price);
    let selected = [];
    price.map((pl) => {
      selected.push(pl.plate_id);
    });
    setSelectedPlates(selected);
  };
  const addPrice = () => {
    setPrices((prev) => [...prev, {}]);
  };

  useEffect(() => {
    getPlateDetails(setLoader, setPlates);
  }, []);

  const getPlateDetails = async (setLoader, setPlates) => {
    try {
      const authData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };

      const { data } = await axios.get(
        `/api/v1/${authData?.type}/plate_inventory`,
        config
      );
      if (data.success) {
        setPlates(data.data.data);
        let selected = {};
        data.data.data.map((plate) => {
          let pair = { [plate.plate_id]: 0 };
          selected = { ...selected, ...pair };
        });
        setSelectedPlates(selected);
        setLoader(false);
      }
    } catch (e) {
      console.log(e);
      setLoader(false);
    }
  };

  const submitDetails = async (prices, company) => {
    try {
      setLoader(true);
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      const { data } = await axios.put(
        `/api/v1/${userData.type}/customer_company/${company}/plate`,
        { plates: prices },
        config
      );
      if (data.success) {
        setLoader(false);
        setSuccess(true);
        setErr("");
        snackRef.current.click();
        navigate("/dashboard/company/customer-companies", {
          state: { success: true, message: "Customer Company Registered" },
        });
      }
    } catch (e) {
      setLoader(false);
      console.log(e);
      setErr(e.response.data.error);
      snackRef.current.click();
    }
  };

  return (
    <>
      <Button
        ref={snackRef}
        style={{ display: "none" }}
        onClick={handleClick({ vertical: "top", horizontal: "center" })}
      >
        Click
      </Button>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        onClose={handleClose}
        key={vertical + horizontal}
      >
        {err ? (
          <Alert mt={2} mb={4} severity="error">
            {err}
          </Alert>
        ) : success ? (
          <Alert mt={2} mb={4} severity="success">
            Company Registered and Plate Details Added successfully
          </Alert>
        ) : null}
      </Snackbar>
      {!loader ? (
        <Card mb={6}>
          <CardContent>
            <Paper style={{ padding: "2%" }}>
              <Grid container spacing={5}>
                <Grid item xs={12} md={12} lg={12}>
                  <Typography variant="h3" gutterBottom>
                    Set Plate Details For Company
                  </Typography>
                </Grid>
                {!prices.length ? (
                  <Grid item xs={12} md={12} lg={12}>
                    <Typography variant="h6">No Plates Added</Typography>
                  </Grid>
                ) : (
                  prices.map((pl, i) => {
                    const check = [];
                    if (selectedPlates.length) {
                      selectedPlates.map((p) => {
                        check.push(p);
                      });
                    }
                    return (
                      <>
                        <Grid item xs={11} lg={11} md={11}>
                          <FormControl fullWidth>
                            <Select
                              id="search-field"
                              value={pl.plate_id || ""}
                              onChange={priceHandle(i, "plate_id")}
                              displayEmpty
                            >
                              <MenuItem value="" disabled>
                                Select Plate
                              </MenuItem>
                              {plates.map((plate) => {
                                if (check.includes(plate._id)) {
                                  return (
                                    <MenuItem disabled value={plate._id}>
                                      {plate.height}X{plate.width}X
                                      {plate.thickness} || {plate.brand.name} ||{" "}
                                      {plate.technology.name} ||{" "} {plate.company}
                                    </MenuItem>
                                  );
                                } else {
                                  return (
                                    <MenuItem value={plate._id}>
                                      {plate.height}X{plate.width}X
                                      {plate.thickness} || {plate.brand.name} ||{" "}
                                      {plate.technology.name} ||{" "} {plate.company}
                                    </MenuItem>
                                  );
                                }
                              })}
                            </Select>
                            <FormHelperText>Select Plate</FormHelperText>
                          </FormControl>
                        </Grid>
                        <Grid item xs={1} md={1} lg={1}>
                          <div style={{ marginTop: 8 }}>
                            <CloseIcon
                              onClick={() => {
                                removePlate(i, pl.plate_id);
                              }}
                            />
                          </div>
                        </Grid>
                        <Grid item xs={12} lg={3} md={6}>
                          <TextField
                            id="standard-number"
                            label="Baking Cost"
                            value={pl.baking_cost}
                            onChange={priceHandle(i, "baking_cost")}
                            type="number"
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} lg={3} md={6}>
                          <TextField
                            id="standard-number"
                            label="Print Cost"
                            value={pl.print_cost}
                            onChange={priceHandle(i, "print_cost")}
                            type="number"
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} lg={3} md={6}>
                          <TextField
                            id="standard-number"
                            label="Selling Cost"
                            value={pl.selling_cost}
                            onChange={priceHandle(i, "selling_cost")}
                            type="number"
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} lg={3} md={6}>
                          <TextField
                            id="standard-number"
                            label="Gripper"
                            value={pl.gripper}
                            onChange={priceHandle(i, "gripper")}
                            type="number"
                            fullWidth
                          />
                        </Grid>
                      </>
                    );
                  })
                )}
                <br />
                <Grid item xs={12} lg={12} md={12}>
                  <Button
                    onClick={addPrice}
                    mr={2}
                    variant="contained"
                    color="primary"
                  >
                    Add Plate
                    <AddIcon />
                  </Button>
                </Grid>
                <Grid item xs={12} lg={12} md={12}>
                  <Button
                    onClick={() => submitDetails(prices, company)}
                    mr={2}
                    variant="contained"
                    color="primary"
                  >
                    Submit Details
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </CardContent>
        </Card>
      ) : (
        <Loading />
      )}
    </>
  );
}
